import { Grid } from "@mui/material";
import { Button } from "../utils";
import { buttonClasses } from "../utils/theme";

function MainContent({ title, children, panel, btnFunc }) {
	return (
		<div className="contentpanel">
			<Grid
				container
				alignItems="center"
				justifyContent="space-between"
			>
				<Grid item>
					<h1 className="title">{title}</h1>
				</Grid>

				{panel && (
					<Grid item>
						<Button
							text="Go Back"
							onClick={btnFunc}
							style={buttonClasses.lynkitOrangeEmpty}
						/>
					</Grid>
				)}
			</Grid>

			<hr className="bgg" style={{ marginTop: "0.5rem" }} />
			{children}
		</div>
	);
}

export default MainContent;
